import React, { useState } from 'react';
import { Pagination, Spin, } from 'antd';
import StarRatingComponent from 'react-star-rating-component';
import { HeartOutlined } from '@ant-design/icons';

const ProductList = ({ products, total, pageSize, onPageChange, loading }) => {
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    };

    const renderProducts = () => {
        return <>
            <div className='row mb-3' style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                    !loading && products ? (products.map((product) => (
                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 position-relative mb-3' key={product.id}>
                            <div className='wishlist text-center'>
                                <HeartOutlined className='fs-6 text-white pt-2 cursor-pointer' />
                            </div>
                            <div className="card h-100">
                                <img src={product.thumbnail} className="card-img" alt="product" style={{ objectFit: 'fill', height: "230px" }} />
                                <div className="card-body">
                                    <h5 className="fs-6">{product.title}</h5>
                                    <span className="desc mb-2 ">{product.description}</span>
                                </div>
                                <div className="card-footer bg-white border-0">
                                    <h5 className=''>${product.price}</h5>
                                    <StarRatingComponent
                                        name="rate2"
                                        editing={false}
                                        starCount={5}
                                        value={product.rating}
                                    />
                                </div>
                            </div>
                        </div>
                    ))) : (null)
                }
            </div>
        </>
    };

    return (
        <div>
            {loading ? (<div className='text-center'><Spin /></div>) : (
                <>
                    {renderProducts()}
                    <Pagination
                        id="paginate"
                        className='text-end  rounded-0 my-5 '
                        current={currentPage}
                        total={total}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                        showLessItems
                    />
                </>
            )}
        </div>
    );
};

export default ProductList;